var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ics-alert__wrapper",class:_vm.alertClass},[_c('div',{staticClass:"ics-alert__content-wrapper"},[_c('span',{staticClass:"ics-alert__icon"}),_vm._v(" "),_c('span',{staticClass:"ics-alert__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }